module.exports = __webpack_public_path__ + "static/media/users.7ccdb5d9.svg";